// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1',
  revision: '7d592ab75',
  branch: 'master',
  date: 'Thu, 03 Sep 2026 14:02:40 GMT'
};